module.exports = require("@swa-ui/dotcom/src/placements/OffersPlacement/ShowTheMath/ShowTheMath.module.scss");